/**
 * Returns the view Id of a particular tree node (Eg:- Inbox is present in both 'Favorites' and 'Folders',
 * but view Id is different for them)
 *
 * @param rootDisplayName - Display name of the root of the tree
 * @param nodeId - Node Identifier
 */
export default function getTreeNodeViewId(rootDisplayName: string, nodeId: string): string {
    return rootDisplayName + nodeId;
}
